
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { namespace } from 'vuex-class';
import VWrapper from '@/components/shared/VWrapper.vue';
import Notification from '@/mixins/Notification';
import { Venue } from '@/interfaces/models/Venue';
import { InjectionRate } from '@/interfaces/models/InjectionRate';
import ReportingApiService, { InjectionRateFilter } from '@/api/http/ReportingApiService';
import { InjectionRateSelection } from '@/interfaces/components/InjectionRateSelection';
import InjectionRateFilterComponent from '@/components/injectionRates/InjectionRateFilter.vue';
import InjectionRateTable from '@/components/injectionRates/InjectionRateTable.vue';

const app = namespace('app');

@Component({
  components: {
    VWrapper,
    InjectionRateFilter: InjectionRateFilterComponent,
    InjectionRateTable,
  },
})
export default class InjectionRates extends mixins(Notification) {
  @app.State('venues') public venues!: Venue[];

  public items: InjectionRate[] = [];

  private readonly api: ReportingApiService = new ReportingApiService();

  public async onChange(selection: InjectionRateSelection) {
    const filter: InjectionRateFilter = {};

    if (selection.from && selection.to) {
      filter.period = `${selection.from}/${selection.to}`;
    }
    if (selection.venue) {
      filter.venue = selection.venue;
    }
    if (selection.customerGroup) {
      filter.customerGroup = selection.customerGroup;
    }
    if (selection.externalOrderProvider) {
      filter.externalOrderProvider = selection.externalOrderProvider;
    }

    try {
      this.$startLoading('injectionRates');
      const { data } = await this.api.getInjectionRates(filter);
      this.items = data;
    } catch (e) {
      this.notifyError('injectionRates.error');
    } finally {
      this.$stopLoading('injectionRates');
    }
  }
}
